import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal-delete-account",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modal-delete-account-title",
  "aria-hidden": "true",
  "data-backdrop": "static"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "modal-delete-account-title"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  id: "modal-delete-account-title"
}
const _hoisted_7 = {
  key: 2,
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-start"
}
const _hoisted_11 = { class: "ml-3" }
const _hoisted_12 = { class: "m-0 mt-2" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_15 = {
  key: 1,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state === 'confirm')
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, "Delete Your Account?"))
            : (_openBlock(), _createElementBlock("h4", _hoisted_6, "Account Deletion Pending")),
          (_ctx.state === 'confirm')
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.state === 'confirm')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fa fa-exclamation-circle text-danger fa-3x" }, null, -1),
                _createElementVNode("div", { class: "ml-3" }, [
                  _createElementVNode("p", { class: "m-0" }, " Your request will be processed within a few hours, and once completed, your account cannot be restored. ")
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-check-circle fa-3x text-warning mt-1" }, null, -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "m-0" }, "We have received your request to delete your account.", -1)),
                  _createElementVNode("p", _hoisted_12, [
                    _cache[3] || (_cache[3] = _createTextVNode("It will be processed and completed within several hours. During this time, the deletion can still be reversed. To cancel the deletion, please contact us immediately at ", -1)),
                    _createElementVNode("a", {
                      href: `mailto:${_ctx.emails.CONTACT}`,
                      class: "modal-delete-account-email"
                    }, _toDisplayString(_ctx.emails.CONTACT), 9, _hoisted_13)
                  ])
                ])
              ]))
        ]),
        (_ctx.state === 'confirm')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[6] || (_cache[6] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary btn-cancel",
                "data-dismiss": "modal",
                tabindex: "1"
              }, "Cancel", -1)),
              _createVNode(_component_BtnSubmit, {
                class: "ml-auto",
                title: 'Yes, delete my account',
                spinner: true,
                submitHandler: _ctx.deleteAccount
              }, null, 8, ["submitHandler"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary ml-auto",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                tabindex: "1"
              }, "Sign Out")
            ]))
      ])
    ])
  ]))
}